<template>
    <section v-if="ready && wantsDelivery" class="pt-0">
        <div class="col-12 col-md-12 mb-3">
            <div class="row">
                <div class="col-12 d-none d-lg-block">
                    <p class="mb-0 d-flex justify-content-between">
                        <strong>
                            {{ $t('vue.checkout.shared.deliveryCosts.deliveryToAddress') }}
                        </strong>
                        <strong>
                            <span class="condensed">
                                {{ $t('vue.checkout.shared.subscriptionCosts.costWithVAT') }} {{ priceWithCurrency(priceWithTax) }}
                            </span>
                        </strong>
                    </p>
                </div>
                <div class="col-12 d-block d-lg-none">
                    <p class="mb-0">
                        <strong>
                            {{ $t('vue.checkout.shared.deliveryCosts.deliveryToAddress') }}</strong>
                    </p>
                    <p class="text-right mb-0">
                        <strong>
                            <span class="condensed">
                                {{ $t('vue.checkout.shared.subscriptionCosts.costWithVAT') }} {{ priceWithCurrency(priceWithTax) }}
                            </span>
                        </strong>
                    </p>
                </div>
            </div>
            <div class="col-12 overview-hr mb-2 mt-2">
            </div>
            <div class="row">
                <div class="col-12 d-flex justify-content-end">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "DeliveryCosts",
        props: {
          currency: {
            type: String,
            default: "€"
          },
            vehicle: {
                type: Object,
                required: true
            },
            subscription: {
                type: Object,
                required: true
            },
            classes: {
                type: String,
                required: false,
                default: "col-12 col-md-12"
            }
        },
        data() {
            return {
                ready: true
            }
        },
        methods: {
            getDeliveryCostsFromSubscription() {
                return parseFloat(this.subscription.details.deliveryCosts);
            },
          priceWithCurrency(price) {
            const isInt = price % 1 === 0;
            if (isInt) return `CHF ${price}.–`
            else return new Intl.NumberFormat ('de-CH', {
               style: 'currency',
               currency: "CHF"
            }).format (price)
          }
        },
        computed: {
            wantsDelivery() {
                let costs = this.getDeliveryCostsFromSubscription();
                let method = this.subscription.details.deliveryMethod;
                return method === 'delivery' && costs > 0;
            },
            priceWithoutTax() {
                let price = this.getDeliveryCostsFromSubscription();
                let priceWithoutTax = (price / 119) * 100;
                return priceWithoutTax
            },
            tax() {
                let price = this.getDeliveryCostsFromSubscription();
                let tax = (price / 119) * 19;
                return tax
            },
            priceWithTax() {
                let price = this.getDeliveryCostsFromSubscription();
                return price
            }
        }
    }
</script>

<style scoped>

</style>
